const CONST = {
    JACKPOT: {
        PLATINUM_MULTIPLIER: 5000,
        GOLD_MULTIPLIER: 150,
        SILVER_MULTIPLIER: 50,
        BRONZE_MULTIPLIER: 20,
    },
    SYMBOLS: {
        WILD: "2",
        COIN: "0",
        SCATTER: "1",
    },
    COLUMNS: 5,
    ROWS: 4
}

export {CONST}